// Shared breakpoints — section scripts read window.BREAKPOINTS, never inline pixels.
// `laptop` is where the hair-types grid takes over from its mobile slider.
window.BREAKPOINTS = { mobile: 768, laptop: 992, tablet: 1024 };

// Fade Up Animation — triggers once per element, only after page load, only if in viewport
window.addEventListener('load', function () {
  const fadeUpObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        fadeUpObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.fade-up').forEach(function (el) {
    fadeUpObserver.observe(el);
  });
});


// Scroll Animation
const elements = document.querySelectorAll(".scroll-animation");
function checkScroll() {
    elements.forEach(el => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.85) {
            el.classList.add("visible");
        }
    });
}
window.addEventListener("scroll", checkScroll);
checkScroll();


// Thumb Animation
const thumbItems = document.querySelectorAll(".thumb-animate");
function checkVisibility() {
    thumbItems.forEach(el => {
        const rect = el.getBoundingClientRect();
        const elementHeight = rect.height;
        const visibleHeight = Math.min(window.innerHeight, rect.bottom) - Math.max(0, rect.top);

        if (visibleHeight >= elementHeight * 0.4) {
            el.classList.add("in-view");
        }
    });
}
window.addEventListener("scroll", checkVisibility);
checkVisibility();


// Reveile Animation
function singleScrollReveal(className = ".reveal-group", visibleOffset = 150, delay = 300) {
    function runReveal() {
        $(className).each(function () {
            var $parent = $(this);
            var windowHeight = $(window).height();
            var elementTop = $parent.offset().top - $(window).scrollTop();

            if (elementTop < windowHeight - visibleOffset) {
                $parent.children().each(function (index) {
                    var $ele = $(this);
                    setTimeout(function () {
                        $ele.addClass("insight");
                    }, index * delay);
                });
            }
        });
    }
    $(window).on("scroll", runReveal);
    $(document).ready(runReveal);
}
singleScrollReveal();

// role="button" elements are focusable but browsers do not fire click on
// Enter/Space for non-button tags. Bridge it so the aria contract holds.
document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var el = e.target.closest('[role="button"]');
    if (!el || el.tagName === 'BUTTON' || el.tagName === 'A') return;
    e.preventDefault();
    el.click();
});

// Announce an action to screen readers via the global live region in theme.liquid.
// Used where a change is only conveyed visually (e.g. a drawer sliding open).
window.announce = function (message) {
    var region = document.getElementById('a11y-live-region');
    if (!region || !message) return;
    // Clearing first makes AT re-announce a message identical to the previous one.
    region.textContent = '';
    window.setTimeout(function () { region.textContent = message; }, 100);
};

// Video modal — native <dialog>, shared by the hero and product review video.
// Hooks: [data-video-modal-open] (aria-controls = dialog id), [data-video-modal],
// [data-video-modal-toggle], [data-video-modal-close].
// Opens with a scale + fade; closes with a fade.
(function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function openModal(modal) {
        modal.showModal();
        document.documentElement.style.overflow = 'hidden';
        playVideo(modal);
        if (reduceMotion.matches) return;

        modal.animate(
            { opacity: [0, 1], transform: ['scale(0.95)', 'scale(1)'] },
            { duration: 400, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
        );
    }

    function closeModal(modal) {
        if (modal.dataset.closing) return;
        if (reduceMotion.matches) {
            modal.close();
            return;
        }
        modal.dataset.closing = 'true';
        var anim = modal.animate(
            { opacity: [1, 0] },
            { duration: 300, easing: 'ease', fill: 'forwards' }
        );
        anim.onfinish = function () {
            modal.close();
            anim.cancel();
            delete modal.dataset.closing;
        };
    }

    function playVideo(modal) {
        var video = modal.querySelector('video');
        var toggle = modal.querySelector('[data-video-modal-toggle]');
        if (!video) return;
        video.play().then(function () {
            if (toggle) toggle.setAttribute('aria-label', 'Pause video');
        }).catch(function () {
            if (toggle) toggle.setAttribute('aria-label', 'Play video');
        });
    }

    document.addEventListener('click', function (e) {
        var opener = e.target.closest('[data-video-modal-open]');
        if (opener) {
            var modal = document.getElementById(opener.getAttribute('aria-controls'));
            if (!modal) return;
            openModal(modal);
            return;
        }

        var toggle = e.target.closest('[data-video-modal-toggle]');
        if (toggle) {
            var toggleModal = toggle.closest('[data-video-modal]');
            var toggleVideo = toggleModal.querySelector('video');
            if (toggleVideo.paused) {
                playVideo(toggleModal);
            } else {
                toggleVideo.pause();
                toggle.setAttribute('aria-label', 'Play video');
            }
            return;
        }

        var closer = e.target.closest('[data-video-modal-close]');
        if (closer) closeModal(closer.closest('[data-video-modal]'));
    });

    document.addEventListener('cancel', function (e) {
        if (!e.target.matches || !e.target.matches('[data-video-modal]')) return;
        e.preventDefault();
        closeModal(e.target);
    }, true);

    document.addEventListener('close', function (e) {
        if (!e.target.matches || !e.target.matches('[data-video-modal]')) return;
        var video = e.target.querySelector('video');
        if (video) {
            video.pause();
            video.currentTime = 0;
        }
        document.documentElement.style.overflow = '';
    }, true);
})();

// Focus trap for off-canvas drawers (menu, cart). Moves focus into the panel on
// open, cycles Tab within it, and restores focus to the trigger on close.
window.focusTrap = (function () {
    var SELECTOR = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]), [role="button"]';
    var panel = null, restoreTo = null, onKey = null;

    function focusable(root) {
        return Array.prototype.filter.call(root.querySelectorAll(SELECTOR), function (el) {
            return el.getClientRects().length > 0;
        });
    }

    return {
        open: function (el) {
            if (!el || panel === el) return;
            restoreTo = document.activeElement;
            panel = el;
            onKey = function (e) {
                if (e.key !== 'Tab' || !panel) return;
                var f = focusable(panel);
                if (!f.length) return;
                var first = f[0], last = f[f.length - 1];
                if (e.shiftKey && document.activeElement === first) {
                    e.preventDefault(); last.focus();
                } else if (!e.shiftKey && document.activeElement === last) {
                    e.preventDefault(); first.focus();
                } else if (!panel.contains(document.activeElement)) {
                    e.preventDefault(); first.focus();
                }
            };
            document.addEventListener('keydown', onKey);
            // wait for the visibility change to apply before focusing
            window.requestAnimationFrame(function () {
                var f = focusable(el);
                if (f.length) f[0].focus();
            });
        },
        close: function () {
            if (onKey) document.removeEventListener('keydown', onKey);
            onKey = null;
            panel = null;
            if (restoreTo && typeof restoreTo.focus === 'function') restoreTo.focus();
            restoreTo = null;
        }
    };
})();
